import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpResponse} from '@angular/common/http';
import {DynamicEnvironmentService} from '../../services/dynamic-environment.service';

export interface JsonResult<TData> {
  valid: boolean;
  message: string;
  data?: TData;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private backendServerUrl = this.serviceEnvironment.apiServicesUrl?.replace(
    /\/$/,
    '');

  constructor(
    private http: HttpClient,
    private serviceEnvironment: DynamicEnvironmentService
  ) {
  }

  get<TResponse>(url: string, objectParams?: any): Observable<HttpEvent<JsonResult<TResponse>>> {
    const objParams = objectParams
      ? Object?.entries(objectParams)?.reduce(
        (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
        {}
      )
      : null;
    return this.http.get<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`, objectParams);
  }


  getForList<TResponse>(url: string){
    return this.http.get<TResponse>(`${this.backendServerUrl}/${url}`, {observe: 'response'}).pipe();
  }

  post<TResponse>(url: string, data: any): Observable<JsonResult<TResponse>> {
    return this.http
      .post<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`, data)
      .pipe();
  }

  forFilterPost<TResponse>(url: string, data: any): Observable<HttpResponse<JsonResult<TResponse>>> {
    return this.http
      .post<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`, data, {observe: 'response'})
      .pipe();
  }

  postBlob(url: string, data: any): Observable<Blob> {
    return this.http.post(`${this.backendServerUrl}${url}`, data, {
      responseType: 'blob',
    });
  }

  put<TResponse>(url: string, data: any): Observable<JsonResult<TResponse>> {
    return this.http
      .put<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`, data)
      .pipe();
  }

  patch<TResponse>(url: string, id: number | object): Observable<JsonResult<TResponse>> {
    return this.http
      .patch<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`, id)
      .pipe();
  }

  delete<TResponse>(url: string): Observable<JsonResult<TResponse>> {
    return this.http
      .delete<JsonResult<TResponse>>(`${this.backendServerUrl}/${url}`)
      .pipe();
  }
}

